import { COOKS_DOC, LISTS_DOC, PERSONAL_LISTS_DOC_PREFIX, RECIPES_DOC } from '@awwyeah/shared';
import type { WebModule } from '../registry';
import { CookModePage } from './pages/CookModePage';
import { RecipeBoxPage } from './pages/RecipeBoxPage';
import { RecipeDetailPage } from './pages/RecipeDetailPage';
import { RecipeFormPage } from './pages/RecipeFormPage';

/**
 * Recipes module (client side, WS-6, ROADMAP §2 Phase 1). Also subscribes to `LISTS_DOC`
 * (read-only here) so the ingredient→list picker can show the household's lists without
 * importing WS-5's lists module internals — per-list `list:<id>` docs are opened on demand
 * at write time via the doc manager directly, not kept subscribed.
 *
 * `COOKS_DOC` is the "Cooked this" log (owner ask 2026-08-18) — this module is its *writer*;
 * the check-in feed reads the same doc to interleave cooks into the family timeline.
 */
export const recipesWebModule: WebModule = {
  id: 'recipes',
  nav: { label: 'Recipes', path: '/recipes', icon: '📖', order: 30 },
  docs: [RECIPES_DOC, COOKS_DOC, LISTS_DOC, PERSONAL_LISTS_DOC_PREFIX],
  routes: [
    { path: '/recipes', component: RecipeBoxPage },
    { path: '/recipes/new', component: RecipeFormPage },
    { path: '/recipes/:id', component: RecipeDetailPage },
    { path: '/recipes/:id/edit', component: RecipeFormPage },
    { path: '/recipes/:id/cook', component: CookModePage },
  ],
};
